import { ReactNode, useEffect, useState } from "react";
import { ISupplier } from "../../../../types/supplier.types";
import { getSupplierById, updateSupplier } from "../../../../common/services/supplier.api";
import { initialState, InitialStateType, SupplierDashboardContext } from "./SupplierDashboard.context";

type Props = {
  children: ReactNode,
  supplierId: string
}

export function SupplierDashboardProvider(props: Props) {

  const [supplier, setSupplier] = useState<ISupplier>(initialState.supplier)

  useEffect(() => {
    async function loadSupplier(supplierId: string) {
      const result = await getSupplierById(supplierId)

      if (result.ok) {
        setSupplier(result.data as ISupplier)
      }
    }

    loadSupplier(props.supplierId)
  }, [props.supplierId])

  async function saveSupplier(dataToSave: ISupplier) {
    try {
      const { ok, data, errors } = await updateSupplier(supplier._id as string, dataToSave)

      if (ok && data) {
        setSupplier(data as ISupplier)
        return { ok, data: data as ISupplier, errors: (errors as [{ message: string, path: string[] }]) }
      }

      return { ok, data: data as ISupplier, errors: errors as [{ message: string, path: string[] }] }
    } catch (err) {
      console.log(err)

      return {
        ok: false,
        data: dataToSave,
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        errors: [{ message: (err as any).message, path: [] }]
      }
    }
  }


  const theState = { supplier, saveSupplier }
  return (
    <SupplierDashboardContext.Provider value={theState as InitialStateType}>
      {props.children}
    </SupplierDashboardContext.Provider>
  )
}